import {$, $$, createElement, removeChildElementByClass} from "./Dom.ts";
import {fadeIn} from "./Animate.ts";


window.Openscop.CKEDITOR = []

export const createACompleterLabel = (element: HTMLElement) => {
    const exist = $('.label-a-completer', element)
    if (!exist){
        const label = createElement('p')
        label.classList.add('fr-badge', 'fr-badge--warning', 'label-a-completer', 'd-none')
        label.innerHTML = 'À completer'
        addLabelInformations(element, label)
        fadeIn(label)
    }
}

export const createAModifierLabel = (element: HTMLElement) => {
    const exist = $('.label-a-modifier', element)
    if (!exist) {
        const label = createElement('span')
        label.classList.add('fr-badge', 'fr-badge--warning', 'label-a-modifier', 'd-none')
        label.innerHTML = 'À modifier'
        addLabelInformations(element, label)
        fadeIn(label)
    }
}

export function initChampACompleter() {
    $$<HTMLInputElement>('.requis').forEach(element => {
        const label = $<HTMLLabelElement>(`label[for="${element.id}"] > span:first-child`)
        if (label) {
            element.addEventListener('change', () => {
                changeLabel(element.value, label)
            })
            changeLabel(element.value, label)
        } else {
            const label = $<HTMLLabelElement>(`label[for="${element.id}"]`)
            if (label) {
                element.addEventListener('change', () => {
                    changeLabel(element.value, label)
                })
                changeLabel(element.value, label)
            }
        }
    })
}

export function initChampAModifier() {
    $$<HTMLInputElement>('.modifier').forEach(element => {
        const label = $<HTMLLabelElement>(`label[for="${element.id}"] > span:first-child`)
        if (label) {
            element.addEventListener('change', () => {
                changeLabel(element.value, label, 'label-a-modifier')
            })
            changeLabel(element.value, label, 'label-a-modifier')
        } else {
            const label = $<HTMLLabelElement>(`label[for="${element.id}"]`)
            if (label) {
                element.addEventListener('change', () => {
                    changeLabel(element.value, label, 'label-a-modifier')
                })
                changeLabel(element.value, label, 'label-a-modifier')
            }
        }
    })
}

export function initInputLabelRequis(element: HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement, label: HTMLLabelElement) {
    if (label) {
        let className = 'label-a-completer'
        if (element.classList.contains('modifier')) {
            className = 'label-a-modifier'
        }
        element.addEventListener('change', () => {
            changeLabel(element.value, label, className)
        })
        changeLabel(element.value, label, className)
    }
}

function changeLabel(value: string, label: HTMLElement, className: string = 'label-a-completer') {
    if (value !== "") {
        removeChildElementByClass(label, className)
    } else {
        if (className === 'label-a-completer') createACompleterLabel(label)
        else createAModifierLabel(label)
    }
}

export function addLabelInformations(label: HTMLElement, elementToPreprend: Element) {
    label?.append(elementToPreprend)
}

export const createFormData = (values: { [key: string]: string | boolean | undefined }[] | { [key: string]: string | boolean | undefined } | string[][]) => {
    const data = new FormData()
    if (Array.isArray(values)) {
        values.forEach((obj) => {
            if (Array.isArray(obj)) {
                data.append(obj[0], obj[1])
            } else {
                Object.entries(obj).forEach(([key, value]) => {
                    if (value) data.append(key, String(value))
                })
            }
        })
    } else {
        Object.entries(values).forEach(([key, value]) => {
            if (value) data.append(key, String(value))
        })
    }
    return data
}